import { render, staticRenderFns } from "./EncuestasTab.vue?vue&type=template&id=52384cf3&"
import script from "./EncuestasTab.vue?vue&type=script&lang=js&"
export * from "./EncuestasTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/franciscoriquelme/Documents/Elipse.ia/Proyectos/elipse-citas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52384cf3')) {
      api.createRecord('52384cf3', component.options)
    } else {
      api.reload('52384cf3', component.options)
    }
    module.hot.accept("./EncuestasTab.vue?vue&type=template&id=52384cf3&", function () {
      api.rerender('52384cf3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/DashboardReportNMV/components/EncuestasTab.vue"
export default component.exports